import React, { Component, Fragment } from "react";
import { shopContext } from "../../contexts/aniplus";
import { withRouter } from "react-router-dom";
// import axios from "axios";

// import { ToastContainer, toast } from "react-toastify"; //토스트(toast)
// import { confirmAlert } from "react-confirm-alert"; //알럿창(alert confirm)
import TimeBlock from "./TimeBlock";

class WeekBlock extends Component {
  render() {
    const { thisWeek, hour, renderItem, theDayOfWeek } = this.props.childProps;
    // let time;
    // //console.log(hour)
    // if (hour <= 9) {
    //   time = "0" + hour.toString();
    // } else {
    //   time = hour;
    // }
    //console.log(theDayOfWeek)
    return (
      <Fragment>
        <div className="div_ul">
          {/*월요일 00시*/}
          <div className={theDayOfWeek === 1 ? "div_li on" : "div_li"}>
            <TimeBlock timeItems={renderItem(thisWeek[1], hour)} />
          </div>
          {/*화요일 00시*/}
          <div className={theDayOfWeek === 2 ? "div_li on" : "div_li"}>
            <TimeBlock timeItems={renderItem(thisWeek[2], hour)} />
          </div>
          {/*수요일 00시*/}
          <div className={theDayOfWeek === 3 ? "div_li on" : "div_li"}>
            <TimeBlock timeItems={renderItem(thisWeek[3], hour)} />
          </div>
          {/*목요일 00시*/}
          <div className={theDayOfWeek === 4 ? "div_li on" : "div_li"}>
            <TimeBlock timeItems={renderItem(thisWeek[4], hour)} />
          </div>
          {/*금요일 00시*/}
          <div className={theDayOfWeek === 5 ? "div_li on" : "div_li"}>
            <TimeBlock timeItems={renderItem(thisWeek[5], hour)} />
          </div>
          {/*토요일 00시*/}
          <div className={theDayOfWeek === 6 ? "div_li on" : "div_li"}>
            <TimeBlock timeItems={renderItem(thisWeek[6], hour)} />
          </div>
          {/*일요일 00시*/}
          <div className={theDayOfWeek === 0 ? "div_li on" : "div_li"}>
            <TimeBlock timeItems={renderItem(thisWeek[7], hour)} />
          </div>
        </div>
      </Fragment>
    );
  }
}

export default shopContext(withRouter(WeekBlock));
